if (!customElements.get('localization-form')) {
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        select: this.querySelector('select'),
        languageInput: this.querySelector('input[name="language_code"]'),
        form: this.querySelector('form'),
      };

      this.elements.select.addEventListener('change', (event) => {
        const selectedOption = event.target.options[event.target.selectedIndex];
        const selectedLanguageCode =
          selectedOption.getAttribute('data-language-code');
        this.elements.languageInput.value = selectedLanguageCode;
      });
    }
  }

  customElements.define('localization-form', LocalizationForm);
}
